import { getLocale } from "../runtime";

const sv_iconshoppingcart = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Varukorg`
};

const iconshoppingcart = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconshoppingcart(inputs)
	return "iconShoppingCart";
};

export { iconshoppingcart as "iconShoppingCart" };